import React from "react";

// Nat Habitat monogram — SVG so it scales sharply everywhere.
// Colors are the portal's own palette (blue → teal) instead of the studio's warm tones.
export function LogoMark({ size = 44, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Nat Habitat"
      role="img"
    >
      <defs>
        <linearGradient id="nh-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1d4ed8" />
          <stop offset="1" stopColor="#0f766e" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#nh-grad)" />
      <rect
        x="2"
        y="2"
        width="60"
        height="60"
        rx="14"
        fill="none"
        stroke="rgba(255,255,255,0.22)"
        strokeWidth="1"
      />
      <g
        fill="#ffffff"
        fontFamily='Georgia, "Times New Roman", serif'
        fontWeight="600"
        letterSpacing="-1"
      >
        <text x="10" y="44" fontSize="30">N</text>
        <text x="34" y="44" fontSize="30">H</text>
      </g>
      <circle cx="32" cy="52" r="1.6" fill="#ffffff" opacity="0.9" />
    </svg>
  );
}

export function LogoLockup({ subtitle = "BOQ · Cost Intelligence", size = 44 }) {
  return (
    <div className="flex items-center gap-3">
      <LogoMark size={size} />
      <div className="leading-tight">
        <div
          className="font-heading font-bold text-foreground tracking-[0.22em]"
          style={{ fontSize: size > 40 ? "1.05rem" : "0.92rem" }}
        >
          NAT HABITAT
        </div>
        <div className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.24em] text-muted-foreground">
          {subtitle}
        </div>
      </div>
    </div>
  );
}
